
export type MarkNotificationAsFailed200Target = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
